import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from "./components/common/pagingUser.vue";
import Common from './components/common.js';
import DatePicker from 'vue2-datepicker';
import swal from 'sweetalert';
import Editor from "./components/common/editor.vue";
import 'vue2-datepicker/index.css';

import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import Alram from './components/common/alram.vue';
import TotalSearchMykeyword from "./components/common/total_search_mykeyword";


Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component('editor', Editor);
Vue.component('star-rating', VueStarRating.default);
Vue.component('dropimg', DropImg);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('alarm', Alram)
// var CircularJSON = require('circular-json');

// 베스트 체험 목록 상태 저장 키 (히스토리 백 복원 전용)
const EXP_BEST_STATE_KEY = 'EXP_BEST_STATE';
// 상세에서 뒤로가기 시에만 목록 상태 복원하도록 하는 플래그 키
const EXP_BEST_NAV_FROM_DETAIL_KEY = 'EXP_BEST_BACK_INTENT';


new Vue({
  el: '#expinfo',
  data: function () {
    return {
      mainName: '베스트체험',
      listBanner: [''],
      //img, doc, video
      isRecommand: false,
      inputChange: '',
      recommender: {},
      map: null,
      isMap: false,
      rc: 1,
      rm: 1,
      rc1: 1,
      //selectbox 적용을 위한 변수들
      isCbpTested: false,
      searchStartDate: '',
      searchEndDate: '',

      isDeclare: false,
      isDetailSearch: true,

      viewYnModel: {
        region: '',
        price: '',
        progress: '',
        trget: '',
        affiliation: '',
        capacity: ''
      },
      searchStr: [ "", "", "", "", ""]
      //////////////////////////////////////////
      , lang: {
        days: ["일", "월", "화", "수", "목", "금", "토"],
        months: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ],
        yearFormat: "YYYY년",
        monthFormat: "MM월",
        monthBeforeYear: false
      },
      //////////////////////////////////////////
      expInfoListModel: {
        aiExpInfoList: [],
        expInfoList: [{"": ""}],
        expInfoCodeList: [],
        //베스트활동, 비대면활동
        isNonface: 'NO',
        region: '',
        ability: '',
        line: '',
        deviseCode: 'region',
        myRegion: "",

        isRegion: "off",

        //맞춤활동검색
        regionList: [],
        scopeList: [],
        progressList: [],
        areaList: [],
        affList: [],
        priceList: [
          {
            "cmm_sys_cd": "price2",
            "cmm_sys_titl": "무료"
          },
          {
            "cmm_sys_cd": "price3",
            "cmm_sys_titl": "~ 5,000"
          },
          {
            "cmm_sys_cd": "price4",
            "cmm_sys_titl": " 5,000 ~ 10,000"
          },
          {
            "cmm_sys_cd": "price5",
            "cmm_sys_titl": "10,000 ~ 30,000"
          },
          {
            "cmm_sys_cd": "price6",
            "cmm_sys_titl": "30,000 ~"
          }
        ],
        regionValues: [],
        priceValues: [],
        progressValues: [],
        scopeValues: [],
        areaValues: [],
        affValues: [],
        allScopeChecked: false,
        allPriceChecked: false,
        allProgressChecked: false,
        allAreaChecked: false,
        allAbilityChecked: false,
        allLineChecked: false,

        startDate: '',
        endDate: '',
        kword: '',

        order: 'newest',
        upCode: 'SGGNV00100',


        totalCount: 0,
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 8,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            let pageType = $("#pageType").val();

            if (pageType == "expSearchList") {
              this.model.fnOnPostSearchList(n);
            } else {
              this.model.fnOnPostList(n);
            }

          }
        }
      },
      isLoading: false, // 목록 조회중 여부
    }
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$;
    }
  },
  mounted: function () {
    this.fnOnLoadInit();
    this.tabSlide();
    this.fnCheckCbpTest();
  },
  updated() {
    this.$nextTick(function () {
      this.tabSlide();
      this.tabSwitch();
    });
  },
  methods: {
    clickFunc: function (event) {
      event.target.focus();// Add me
    },
    fnOnLoadInit: function () {
      let pageType = $("#pageType").val();
      let vm = this;
      vm.fnGetExpInfoReportBanner();

      if (pageType == "expBestList") {
        // 상세에서 히스토리 백으로 돌아온 경우 목록 상태 복원 시도
        let restored = false;
        try {
          const path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
          const isBestPage = path === '/customer/expinfo/bestExperience';
          const fromDetail = sessionStorage.getItem(EXP_BEST_NAV_FROM_DETAIL_KEY) === '1';
          // 브라우저 뒤로가기 탐지 (기존 동작 유지)
          let isBack = false;
          try {
            const nav = (performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation') : null;
            if (nav && nav.length && nav[0].type === 'back_forward') {
              isBack = true;
            } else if (window.performance && window.performance.navigation) {
              // legacy API: 2 = TYPE_BACK_FORWARD
              isBack = (window.performance.navigation.type === 2);
            }
          } catch (e) {}
          // detailExpinfo에서 "목록으로" 클릭 같은 링크 이동만 허용하기 위해 referrer로 상세페이지 유입 확인
          const ref = (document && document.referrer) ? document.referrer : '';
          const fromDetailPage = ref.indexOf('/customer/expinfo/detailExpinfo') >= 0;

          // 조건: (뒤로가기) 또는 (상세 -> 목록 링크) 인 경우에만 복원
          if (isBestPage && fromDetail && (isBack || fromDetailPage)) {
            restored = vm.restoreExpBestState();
            // 복원은 1회성
            sessionStorage.removeItem(EXP_BEST_NAV_FROM_DETAIL_KEY);
          }
        } catch (e) { console.log('[EXP_BEST] restore check error', e); }

        let search = $("#search").val();
        if (search)
        {
          vm.searchStr = search.split("_");
        }

        vm.fnSetRegionList();
        vm.fnOnSetCode('DIVNVSCLNV000000'); // 대상 ('scope');
        vm.fnOnSetCode('IXVNV00000'); // 진행상태 ('progress');
        vm.fnOnSetCode('CPCNVADMNV000000'); // 역량 ('area');
        vm.fnOnSetCode('AFLNVADMNV000000'); // 계열 ('aff');

        if (vm.searchStr[3])
        {
          vm.expInfoListModel.priceList.forEach((item) => {
            if (vm.searchStr[3] == item.cmm_sys_cd)
            {
              vm.viewYnModel.price = item;
            }
          });
        }

        vm.mainName = '베스트 체험'
        vm.expInfoListModel.isNonface = 'NO'
        vm.fnOnSearchCode('aff');
        let order = $("#order").val();
        if (order != null && order != "") {
          if (order == "hit") {
            vm.expInfoListModel.order = "hit";
            // $("#new").removeClass("on");
            // $("#hit").addClass("on");
          }
        }

        let tabIdx = $("#tabIdx").val();
        let subTab = $("#subTab").val();
        let pageNum = $("#pageNum").val();

        // if(tabIdx != null && tabIdx != ''){
        //     vm.fnOnBackSpacePostList(tabIdx, subTab, pageNum);
        // }else{
        //     vm.fnOnPostList(1);
        //     vm.tabFocus("all");
        // }
        // 복원에 성공했다면 최초 조회는 생략하되, AI 리스트는 항상 조회
        if (!restored) {
          vm.fnOnPostList(1, search);
        } else {
          vm.fnFetchAiList();
        }


      } else if (pageType == "expSearchList") {

        let param = {};
        let usrKey = $("#userKey").val();


        if (usrKey != null && usrKey != undefined && usrKey != "") {
          Axios.post("/api/cbp/isTest", param).then(function (response) {

            let resultCnt = response.data.resultCnt;

            if (resultCnt == 0) {    //역량검사 안했으면 alert
              swal({
                text: '역량진단을 수행하지 않았습니다. \n프로그램 검색 전 역량진단을 받아보시겠습니까?',
                // icon        : vm.fnOnLoadSwalImageData('info'),
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true,
                  },
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: true,
                  }
                },
                dangerMode: false,
              }).then(result => {
                if (result) {
                  location.href = "/youthnavi/mypage/user/cbpTest";
                }

              });
            } else {
              vm.expInfoListModel.areaValues = response.data.paramText.split("|");
              vm.expInfoListModel.affValues = response.data.paramText1.split("|");
            }
          }).catch(function (ex) {
            console.log(ex);

          });
        }


        vm.fnSetRegionList();
        vm.mainName = '맞춤 활동 검색'
        vm.fnOnSearchCode('scope');
        vm.fnOnSearchCode('progress');
        vm.fnOnSearchCode('area');
        vm.fnOnSearchCode('aff');

        let _search = $("#search").val();

        let urlParameter = window.location.search;

        if (_search != null && _search != "") {
          vm.expInfoListModel.areaValues = [_search];
          vm.fnLinkSearchList(_search);
        } else if (urlParameter != null && urlParameter != "") {
          vm.fnOnBackPostSearchList(1);
        } else {
          vm.fnOnPostSearchList(1);
        }

      } else if (pageType == "expNonfaceList") {
        vm.fnSetRegionList();
        vm.mainName = '비대면 체험'
        vm.expInfoListModel.isNonface = 'YES'
        vm.fnOnSearchCode('aff');
        let order = $("#order").val();
        if (order != null && order != "") {
          if (order == "hit") {
            vm.expInfoListModel.order = "hit";
            // $("#new").removeClass("on");
            // $("#hit").addClass("on");
          }
        }

        let tabIdx = $("#tabIdx").val();
        let subTab = $("#subTab").val();
        let pageNum = $("#pageNum").val();

        if (tabIdx != null && tabIdx != '') {
          vm.fnOnBackSpacePostList(tabIdx, subTab, pageNum);
        } else {
          vm.fnOnPostList(1);
          vm.tabFocus("all");
        }
      }
    }
    , fnCheckCbpTest: function() {
      let vm = this;
      let param = {};
      let usrKey = $("#usrKey").val();
      param.usrKey = usrKey;
      if (usrKey != null && usrKey != undefined && usrKey != "") {
        Axios.post("/api/cbp/isTest", param).then(function (response) {

          let resultCnt = response.data.resultCnt;
          console.log("cbp", resultCnt);
          if (resultCnt == 0) {    //역량검사 안했으면
            vm.isCbpTested = false;
          } else {
            vm.isCbpTested = true;
          }
        }).catch(function (ex) {
          console.log(ex);

        });
      }
    }
    , allReset: function () {
      let vm = this;
      vm.viewYnModel.region = null;
      vm.viewYnModel.trget = null;
      vm.viewYnModel.affiliation = null;
      vm.viewYnModel.capacity = null;
      vm.viewYnModel.price = null;
      vm.viewYnModel.progress = null;

      vm.fnOnPostList(1);

    }
    , getSearch: async function () {
      let vm = this;

      let param = {
        region: vm.viewYnModel.region ? vm.viewYnModel.region.cmm_sys_cd : '',
        trget: vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : '',
        affiliation: vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : '',
        capacity: vm.viewYnModel.capacity ? vm.viewYnModel.capacity.cmm_sys_cd : '',
        price: vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : '',
        progress: vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : ''
      }

      console.log(param);
      return;

      Axios.get("/search/totalCustomSearch.do", {params: param}).then(function (response) {
        vm.viewModel = response.data;
        vm.viewModel.totalCount = 0;
        for (let key in vm.viewModel) {
          if(vm.viewModel[key].nameEn != 'afterschool' && vm.viewModel[key].nameEn != 'space' && vm.viewModel[key].nameEn != 'teacher') {
            const map = vm.viewModel[key];
            const tot = map['totalCount'];
            if (tot != undefined) {
              vm.viewModel.totalCount += tot;
            }
            vm.viewYnModel[key] = tot > 0 // 결과건수가 있을 때에만 보임
          }
        }
        if (vm.viewModel.program.searchResultList.length > 0) {
          vm.viewModel.program.searchResultList.forEach(function (item) {
            const nameStr = item.AFFILIATION_NAME; // 융합,예체능
            let affList = [];

            vm.viewModel.program.searchResultList.forEach(function (item) {
              item.isZzim = item.zzimYn === "Y";
            });

            if (nameStr == null || nameStr === '') {
              item.affList = affList;
            } else {

              let _affNm = nameStr.split(",");

              _affNm.forEach(function (item) {
                let affCode = "";

                switch (item) {
                  case "인문과학":
                    affCode = "dpt_label dpt01";
                    break;
                  case "사회과학":
                    affCode = "dpt_label dpt02";
                    break;
                  case "상경":
                    affCode = "dpt_label dpt03";
                    break;
                  case "사범(교육)":
                    affCode = "dpt_label dpt04";
                    break;
                  case "자연과학":
                    affCode = "dpt_label dpt05";
                    break;
                  case "공학":
                    affCode = "dpt_label dpt06";
                    break;
                  case "의학/보건":
                    affCode = "dpt_label dpt07";
                    break;
                  case "예체능":
                    affCode = "dpt_label dpt08";
                    break;
                  case "융합":
                    affCode = "dpt_label dpt09";
                    break;
                }

                let affItem = {code: affCode, title: item}
                affList.push(affItem);
              });
              item.affList = affList;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });


      // 연관검색어
      const retRecomm = await Axios.get("/search/recommendSimple.do", {params: {query: vm.searchModel.kword}});
      // console.log("retRecomm = ", retRecomm)
      this.recommendList = retRecomm?.data?.list ?? []

      // this.recommendList =

    }
    , fnSetStartDate: function (e) {
      this.expInfoListModel.startDate = e;
    }
    , fnSetEndDate: function (e) {
      this.expInfoListModel.endDate = e;
    }

    // 배너 조회
    , fnGetExpInfoReportBanner: function () {
      const vm = this;
      let _param = {
        uidKey: 'BANNVLOCNV00300'
        , divide: 'custommer'
      }
      let param = {
        pageNo: 0,
        pageSize: 10,
        paramText: JSON.stringify(_param)
      };

      Axios.post("/api/admin/banner/list", param).then(function (response) {
        vm.listBanner = response.data.list;
        console.log('exp ListBanner', vm.listBanner);
      }).catch(function (ex) {
        console.log(ex);
      });
    }

    //미래준비활동, 비대면체험, 맞춤활동검색
    , fnOnPostCode: function () {
      let vm = this;
      let param = {
        searchCode: vm.expInfoListModel.upCode
      };
      Axios.post("/api/expinfo/code", param).then(function (response) {

        vm.expInfoListModel.expInfoCodeList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    // AI 추천 리스트는 저장/복원과 무관하게 항상 조회
    , fnFetchAiList: function () {
      let vm = this;
      vm.expInfoListModel.aiExpInfoList = [];
      let param = {};
      Axios.post("/api/expinfo/aiList", param).then(function (response) {
        response.data.expinfoList.forEach(function (item) {
          item.isZzim = item.zzimYn === "Y";
          item.startDate = item.startDate.split(' ')[0].replaceAll('-','.');
          item.endDate = item.endDate.split(' ')[0].replaceAll('-','.');
          if(item.filePath != null) {
            item.filePath = item.filePath.replaceAll('/var/uploadfiles', '');
          }
          vm.expInfoListModel.aiExpInfoList.push(item);
        });

        vm.expInfoListModel.aiExpInfoList.forEach(function (item) {
          let affList = [];
          if (item.affNm != null && item.affNm != "") {
            let _affNm = item.affNm.split(",");

            _affNm.forEach(function (item) {
              let affCode = "";

              switch (item) {
                case "인문과학":
                  affCode = "dpt_label dpt01";
                  break;
                case "사회과학":
                  affCode = "dpt_label dpt02";
                  break;
                case "상경":
                  affCode = "dpt_label dpt03";
                  break;
                case "사범(교육)":
                  affCode = "dpt_label dpt04";
                  break;
                case "자연과학":
                  affCode = "dpt_label dpt05";
                  break;
                case "공학":
                  affCode = "dpt_label dpt06";
                  break;
                case "의학/보건":
                  affCode = "dpt_label dpt07";
                  break;
                case "예체능":
                  affCode = "dpt_label dpt08";
                  break;
                case "융합":
                  affCode = "dpt_label dpt09";
                  break;
              }

              let affItem = {code: affCode, title: item}
              affList.push(affItem);
            });

          }
          item.affList = affList;
        });

        try { $('#load-2').hide(); } catch (e) {}
      }).catch(function (ex) {
        console.log(ex);
        try { $('#load-2').hide(); } catch (e) {}
      });
    }
    , fnOnPostList: function (pageNumber, search) {
      let vm = this;
      vm.isLoading = true; // 로딩중 시작
      $('#load-2').show();
      vm.expInfoListModel.pager.pageNo = pageNumber;

      if (pageNumber == 1) vm.expInfoListModel.expInfoList = [];
      /*let param = {
        pageNo: vm.expInfoListModel.pager.pageNo
        , pageSize: 32
        , region: vm.expInfoListModel.region
        , ability: vm.expInfoListModel.ability
        , line: vm.expInfoListModel.line
        , order: vm.expInfoListModel.order
        , isNonface: vm.expInfoListModel.isNonface
      };*/

      let param;
      if (search) {
        param = {
          pageNo: vm.expInfoListModel.pager.pageNo
          , pageSize: 32
          , order: vm.expInfoListModel.order
          , isNonface: vm.expInfoListModel.isNonface

          , region: vm.searchStr[0]
          , trget: vm.searchStr[1]
          , affiliation: vm.searchStr[2]
          , capacity: vm.viewYnModel.capacity ? vm.viewYnModel.capacity.cmm_sys_cd : ''
          , pricetype: vm.searchStr[3]
          , progress: vm.searchStr[4]
        }
      }
      else
      {
        param = {
          pageNo: vm.expInfoListModel.pager.pageNo
          , pageSize: 32
          , order: vm.expInfoListModel.order
          , isNonface: vm.expInfoListModel.isNonface
          , region: vm.viewYnModel.region ? vm.viewYnModel.region.cmm_sys_cd : ''
          , trget: vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : ''
          , affiliation: vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : ''
          , capacity: vm.viewYnModel.capacity ? vm.viewYnModel.capacity.cmm_sys_cd : ''
          , pricetype: vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : ''
          , progress: vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : ''
        }
      }

      Axios.post("/api/expinfo/list", param).then(function (response) {

        vm.expInfoListModel.pager.totalSize = response.data.totalCount;
        vm.expInfoListModel.pager.pageNum = (vm.expInfoListModel.pager.pageNo * vm.expInfoListModel.pager.rowSize) - vm.expInfoListModel.pager.rowSize;
        // Pager.props = Pager.methods.createPager(vm.expInfoListModel.pager, vm, "list");

        // vm.expInfoListModel.expInfoList = [];
        response.data.expinfoList.forEach(function (item) {
          item.isZzim = item.zzimYn === "Y";
          item.startDate = item.startDate?.split(' ')[0].replaceAll('-','.');
          item.endDate = item.endDate?.split(' ')[0].replaceAll('-','.');
          if(item.filePath != null) {
            item.filePath = item.filePath.replaceAll('/var/uploadfiles', '');
          }
          vm.expInfoListModel.expInfoList.push(item);
        });

        vm.expInfoListModel.expInfoList.forEach(function (item) {
          let affList = [];
          if (item.affNm != null && item.affNm != "") {
            let _affNm = item.affNm.split(",");

            _affNm.forEach(function (item) {
              let affCode = "";

              switch (item) {
                case "인문과학":
                  affCode = "dpt_label dpt01";
                  break;
                case "사회과학":
                  affCode = "dpt_label dpt02";
                  break;
                case "상경":
                  affCode = "dpt_label dpt03";
                  break;
                case "사범(교육)":
                  affCode = "dpt_label dpt04";
                  break;
                case "자연과학":
                  affCode = "dpt_label dpt05";
                  break;
                case "공학":
                  affCode = "dpt_label dpt06";
                  break;
                case "의학/보건":
                  affCode = "dpt_label dpt07";
                  break;
                case "예체능":
                  affCode = "dpt_label dpt08";
                  break;
                case "융합":
                  affCode = "dpt_label dpt09";
                  break;
              }

              let affItem = {code: affCode, title: item}
              affList.push(affItem);
            });

          }
          item.affList = affList;

        });

        vm.rm = Math.min(5, Math.floor(vm.expInfoListModel.expInfoList.length / 4))
        vm.expInfoListModel.myRegion = response.data.myRegion;
        // 첫 페이지 또는 이어보기 등 상태 저장 (expBestList 전용)
        const pageType = $("#pageType").val();
        if (pageType === 'expBestList') {
          if (vm.expInfoListModel.pager.pageNo === 1) {
            sessionStorage.removeItem(EXP_BEST_STATE_KEY);
          }
          vm.saveExpBestState(true);
        }
        // AI 리스트 별도 호출 (저장/복원 영향 X)
        vm.fnFetchAiList();




      }).catch(function (ex) {
        vm.isLoading = false; // 로딩중 종료
        $('#load-2').hide();
      });
    }

    , fnOnBackSpacePostList: function (tabIdx, subTab, pageNum) {
      let vm = this;
      vm.expInfoListModel.pager.pageNo = pageNum;


      if (tabIdx == 2) {
        let upCode = 'SGGNV00100';
        vm.expInfoListModel.upCode = upCode;
        vm.expInfoListModel.deviseCode = 'region';
        $("#findTag").children("li").removeClass("on");

        let param = {};
        Axios.post("/api/expinfo/setSeoulAreaList", param).then(function (response) {

          vm.expInfoListModel.regionList = response.data.expinfoCodeList;
          vm.expInfoListModel.expInfoCodeList = response.data.expinfoCodeList;

          let region = subTab;

          vm.expInfoListModel.region = region;
          vm.expInfoListModel.ability = '';
          vm.expInfoListModel.line = '';
          vm.expInfoListModel.isRegion = "off";

          setTimeout(function () {
            $("#" + region).children('a').trigger('click');
            vm.fnOnclickTab(region, pageNum);
          }, 500);
        }).catch(function (ex) {
          console.log(ex);
        });

      } else if (tabIdx == 3) {
        let upCode = 'CPCNVADMNV000000';
        vm.expInfoListModel.upCode = upCode;
        vm.expInfoListModel.deviseCode = 'ability';
        $("#findTag").children("li").removeClass("on");

        let param = {
          searchCode: vm.expInfoListModel.upCode
        };
        Axios.post("/api/expinfo/code", param).then(function (response) {

          vm.expInfoListModel.expInfoCodeList = response.data.expinfoCodeList;

          let ability = subTab;

          vm.expInfoListModel.region = '';
          vm.expInfoListModel.ability = ability;
          vm.expInfoListModel.line = '';
          vm.expInfoListModel.isRegion = "off";

          setTimeout(function () {
            $("#" + ability).children('a').trigger('click');
            vm.fnOnclickTab(ability, pageNum);
          }, 500);

        }).catch(function (ex) {
          console.log(ex);
        });

      } else if (tabIdx == 1) {
        let upCode = 'AFLNVADMNV000000';
        vm.expInfoListModel.upCode = upCode;
        vm.expInfoListModel.deviseCode = 'line';
        $("#findTag").children("li").removeClass("on");

        let param = {
          searchCode: vm.expInfoListModel.upCode
        };
        Axios.post("/api/expinfo/code", param).then(function (response) {

          vm.expInfoListModel.expInfoCodeList = response.data.expinfoCodeList;

          let line = subTab;

          vm.expInfoListModel.region = '';
          vm.expInfoListModel.ability = '';
          vm.expInfoListModel.line = line;
          vm.expInfoListModel.isRegion = "off";

          setTimeout(function () {
            $("#" + line).children('a').trigger('click');
            vm.fnOnclickTab(line, pageNum);
          }, 500);

        }).catch(function (ex) {
          console.log(ex);
        });

      }
    }
    // 기본 검색
    , fnOnPostSearchList: function (pageNumber) {
      let vm = this;
      vm.isLoading = true; // 로딩중 시작
      let param = {};

      if (vm.isDetailSearch) {
        param = {
          pageNo: vm.expInfoListModel.pager.pageNo
          , pageSize: vm.expInfoListModel.pager.rowSize
          , regionList: vm.expInfoListModel.regionValues
          , priceList: vm.expInfoListModel.priceValues
          , progressList: vm.expInfoListModel.progressValues
          , scopeList: vm.expInfoListModel.scopeValues
          , areaList: vm.expInfoListModel.areaValues
          , lineList: vm.expInfoListModel.affValues
          , order: vm.expInfoListModel.order
          , kword: vm.expInfoListModel.kword
          , startDate: vm.expInfoListModel.startDate
          , endDate: vm.expInfoListModel.endDate
        };
      } else {
        param = {
          pageNo: vm.expInfoListModel.pager.pageNo
          , pageSize: vm.expInfoListModel.pager.rowSize
          , order: vm.expInfoListModel.order
          , kword: vm.expInfoListModel.kword
        };
      }

      Axios.post("/api/expinfo/activitySearch", param).then(function (response) {

        let result = response.data.result;

        if (result == -999) {
          swal({
            title: '검색 실패',
            text: '검색에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.expInfoListModel.pager.totalSize = response.data.totalCount;
          vm.expInfoListModel.pager.pageNum = (vm.expInfoListModel.pager.pageNo * vm.expInfoListModel.pager.rowSize) - vm.expInfoListModel.pager.rowSize;
          Pager.props = Pager.methods.createPager(vm.expInfoListModel.pager, vm, "list");

          vm.expInfoListModel.expInfoList = [];

          response.data.expinfoList.forEach(function (item) {
            item.isZzim = item.zzimYn === "Y";
            vm.expInfoListModel.expInfoList.push(item);
          });

          vm.expInfoListModel.expInfoList.forEach(function (item) {
            let affList = [];

            if (item.affNm != null && item.affNm != "") {
              let _affNm = item.affNm.split(",");

              _affNm.forEach(function (item) {
                let affCode = "";

                switch (item) {
                  case "인문과학":
                    affCode = "dpt_label dpt01";
                    break;
                  case "사회과학":
                    affCode = "dpt_label dpt02";
                    break;
                  case "상경":
                    affCode = "dpt_label dpt03";
                    break;
                  case "사범(교육)":
                    affCode = "dpt_label dpt04";
                    break;
                  case "자연과학":
                    affCode = "dpt_label dpt05";
                    break;
                  case "공학":
                    affCode = "dpt_label dpt06";
                    break;
                  case "의학/보건":
                    affCode = "dpt_label dpt07";
                    break;
                  case "예체능":
                    affCode = "dpt_label dpt08";
                    break;
                  case "융합":
                    affCode = "dpt_label dpt09";
                    break;
                }

                let affItem = {code: affCode, title: item}
                affList.push(affItem);
              });
            }

            item.affList = affList;
          });
        }
        vm.isLoading = false;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    // 역량계열 전용 검색
    , fnLinkSearchList: function (searchCode) {
      let vm = this;
      vm.expInfoListModel.pager.pageNo = 1;
      let param = {
        pageNo: vm.expInfoListModel.pager.pageNo
        , pageSize: vm.expInfoListModel.pager.rowSize
        , regionList: vm.expInfoListModel.regionValues
        , priceList: vm.expInfoListModel.priceValues
        , progressList: vm.expInfoListModel.progressValues
        , scopeList: vm.expInfoListModel.scopeValues
        , areaList: [searchCode]
        , lineList: vm.expInfoListModel.affValues
        , order: vm.expInfoListModel.order
        , kword: vm.expInfoListModel.kword
        , startDate: vm.expInfoListModel.startDate
        , endDate: vm.expInfoListModel.endDate
      };

      Axios.post("/api/expinfo/activitySearch", param).then(function (response) {

        let result = response.data.result;

        if (result == -999) {
          swal({
            title: '검색 실패',
            text: '검색에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.expInfoListModel.pager.totalSize = response.data.totalCount;
          vm.expInfoListModel.pager.pageNum = (vm.expInfoListModel.pager.pageNo * vm.expInfoListModel.pager.rowSize) - vm.expInfoListModel.pager.rowSize;
          Pager.props = Pager.methods.createPager(vm.expInfoListModel.pager, vm, "list");

          vm.expInfoListModel.expInfoList = [];

          response.data.expinfoList.forEach(function (item) {
            item.isZzim = item.zzimYn === "Y";
            vm.expInfoListModel.expInfoList.push(item);
          });

          vm.expInfoListModel.expInfoList.forEach(function (item) {
            let affList = [];

            if (item.affNm != null && item.affNm != "") {
              let _affNm = item.affNm.split(",");

              _affNm.forEach(function (item) {
                let affCode = "";

                switch (item) {
                  case "인문과학":
                    affCode = "dpt_label dpt01";
                    break;
                  case "사회과학":
                    affCode = "dpt_label dpt02";
                    break;
                  case "상경":
                    affCode = "dpt_label dpt03";
                    break;
                  case "사범(교육)":
                    affCode = "dpt_label dpt04";
                    break;
                  case "자연과학":
                    affCode = "dpt_label dpt05";
                    break;
                  case "공학":
                    affCode = "dpt_label dpt06";
                    break;
                  case "의학/보건":
                    affCode = "dpt_label dpt07";
                    break;
                  case "예체능":
                    affCode = "dpt_label dpt08";
                    break;
                  case "융합":
                    affCode = "dpt_label dpt09";
                    break;
                }

                let affItem = {code: affCode, title: item}
                affList.push(affItem);
              });
            }

            item.affList = affList;
          });
          console.log(vm.expInfoListModel.expInfoList.length)
          vm.rm = Math.min(5, Math.floor(vm.expInfoListModel.expInfoList.length / 4))
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    // 뒤로가기용 URL 조건 검색
    , fnOnBackPostSearchList: function (pageNumber) {
      let vm = this;

      let param = {};

      let region = ($("#regionModel").val() == null || $("#regionModel").val() == "") ? "" : decodeURIComponent($("#regionModel").val());
      vm.expInfoListModel.regionValues = (region == "") ? [] : region.split("|");

      let price = ($("#priceModel").val() == null || $("#priceModel").val() == "") ? "" : decodeURIComponent($("#priceModel").val());
      vm.expInfoListModel.priceValues = (price == "") ? [] : price.split("|");

      let progress = ($("#progressModel").val() == null || $("#progressModel").val() == "") ? "" : decodeURIComponent($("#progressModel").val());
      vm.expInfoListModel.progressValues = (progress == "") ? [] : progress.split("|");

      let scope = ($("#scopeModel").val() == null || $("#scopeModel").val() == "") ? "" : decodeURIComponent($("#scopeModel").val());
      vm.expInfoListModel.scopeValues = (scope == "") ? [] : scope.split("|");

      let area = ($("#areaModel").val() == null || $("#areaModel").val() == "") ? "" : decodeURIComponent($("#areaModel").val());
      vm.expInfoListModel.areaValues = (area == "") ? [] : area.split("|");

      let line = ($("#lineModel").val() == null || $("#lineModel").val() == "") ? "" : decodeURIComponent($("#lineModel").val());
      vm.expInfoListModel.affValues = (line == "") ? [] : line.split("|");

      vm.expInfoListModel.kword = ($("#kword").val() == null || $("#kword").val() == "") ? "" : $("#kword").val();
      vm.expInfoListModel.startDate = ($("#startDate").val() == null || $("#startDate").val() == "") ? "" : $("#startDate").val();
      vm.expInfoListModel.endDate = ($("#endDate").val() == null || $("#endDate").val() == "") ? "" : $("#endDate").val();

      vm.expInfoListModel.pager.pageNo = ($("#pageNum").val() == null || $("#pageNum").val() == "") ? pageNumber : $("#pageNum").val();


      if (vm.isDetailSearch) {
        param = {
          pageNo: vm.expInfoListModel.pager.pageNo
          , pageSize: vm.expInfoListModel.pager.rowSize
          , regionList: vm.expInfoListModel.regionValues
          , priceList: vm.expInfoListModel.priceValues
          , progressList: vm.expInfoListModel.progressValues
          , scopeList: vm.expInfoListModel.scopeValues
          , areaList: vm.expInfoListModel.areaValues
          , lineList: vm.expInfoListModel.affValues
          , order: vm.expInfoListModel.order
          , kword: vm.expInfoListModel.kword
          , startDate: vm.expInfoListModel.startDate
          , endDate: vm.expInfoListModel.endDate
        };
      } else {
        param = {
          pageNo: vm.expInfoListModel.pager.pageNo
          , pageSize: vm.expInfoListModel.pager.rowSize
          , order: vm.expInfoListModel.order
          , kword: vm.expInfoListModel.kword
        };
      }


      Axios.post("/api/expinfo/activitySearch", param).then(function (response) {

        let result = response.data.result;

        if (result == -999) {
          swal({
            title: '검색 실패',
            text: '검색에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.expInfoListModel.pager.totalSize = response.data.totalCount;
          vm.expInfoListModel.pager.pageNum = (vm.expInfoListModel.pager.pageNo * vm.expInfoListModel.pager.rowSize) - vm.expInfoListModel.pager.rowSize;
          Pager.props = Pager.methods.createPager(vm.expInfoListModel.pager, vm, "list");

          vm.expInfoListModel.expInfoList = [];

          response.data.expinfoList.forEach(function (item) {
            item.isZzim = item.zzimYn === "Y";
            vm.expInfoListModel.expInfoList.push(item);
          });

          vm.expInfoListModel.expInfoList.forEach(function (item) {
            let affList = [];

            if (item.affNm != null && item.affNm != "") {
              let _affNm = item.affNm.split(",");

              _affNm.forEach(function (item) {
                let affCode = "";

                switch (item) {
                  case "인문과학":
                    affCode = "dpt_label dpt01";
                    break;
                  case "사회과학":
                    affCode = "dpt_label dpt02";
                    break;
                  case "상경":
                    affCode = "dpt_label dpt03";
                    break;
                  case "사범(교육)":
                    affCode = "dpt_label dpt04";
                    break;
                  case "자연과학":
                    affCode = "dpt_label dpt05";
                    break;
                  case "공학":
                    affCode = "dpt_label dpt06";
                    break;
                  case "의학/보건":
                    affCode = "dpt_label dpt07";
                    break;
                  case "예체능":
                    affCode = "dpt_label dpt08";
                    break;
                  case "융합":
                    affCode = "dpt_label dpt09";
                    break;
                }

                let affItem = {code: affCode, title: item}
                affList.push(affItem);
              });
            }

            item.affList = affList;
          });
          console.log(vm.expInfoListModel.expInfoList.length)
          vm.rm = Math.min(5, Math.floor(vm.expInfoListModel.expInfoList.length / 4))
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnChangeTab(_devise) {
      let vm = this;
      vm.expInfoListModel.deviseCode = _devise;

      if (_devise == 'region') {
        let upCode = 'SGGNV00100';
        vm.expInfoListModel.upCode = upCode;
        vm.fnSetRegionList();
        $("#findTag").children("li").removeClass("on");
        $("#findTag").children("li:eq(0)").addClass("on");
        vm.fnOnclickTab('all');
        vm.expInfoListModel.isRegion = "off";
        vm.tabFocus("all");
      } else if (_devise == 'ability') {
        let upCode = 'CPCNVADMNV000000';
        vm.expInfoListModel.upCode = upCode;
        vm.fnOnPostCode();
        $("#findTag").children("li").removeClass("on");
        $("#findTag").children("li:eq(0)").addClass("on");
        vm.fnOnclickTab('all');
        vm.expInfoListModel.isRegion = "off";
        vm.tabFocus("all");
      } else if (_devise == 'line') {
        let upCode = 'AFLNVADMNV000000';
        vm.expInfoListModel.upCode = upCode;
        vm.fnOnPostCode();
        $("#findTag").children("li").removeClass("on");
        $("#findTag").children("li:eq(0)").addClass("on");
        vm.fnOnclickTab('all');
        vm.expInfoListModel.isRegion = "off";
        vm.tabFocus("all");
      }
    }
    , fnOnclickTab(_code, goPageNum = 1) {
      let vm = this;
      let _deviseCode = this.expInfoListModel.deviseCode;

      if (_deviseCode == 'region') {
        vm.expInfoListModel.region = _code;
        vm.expInfoListModel.ability = '';
        vm.expInfoListModel.line = '';

        console.log("region = " + vm.expInfoListModel.region);

        if (_code != vm.expInfoListModel.myRegion) {
          vm.expInfoListModel.isRegion = "off";
        }
        console.log(vm.expInfoListModel.expInfoCodeList);
      } else if (_deviseCode == 'ability') {
        vm.expInfoListModel.region = '';
        vm.expInfoListModel.ability = _code;
        vm.expInfoListModel.line = '';
        vm.expInfoListModel.isRegion = "off";

        console.log("ability = " + vm.expInfoListModel.ability);
        console.log(vm.expInfoListModel.expInfoCodeList);
      } else if (_deviseCode == 'line') {
        vm.expInfoListModel.region = '';
        vm.expInfoListModel.ability = '';
        vm.expInfoListModel.line = _code;
        vm.expInfoListModel.isRegion = "off";

        console.log("line = " + vm.expInfoListModel.line);
        console.log(vm.expInfoListModel.expInfoCodeList);
      }

      vm.expInfoListModel.pager.pageNo = goPageNum;
      vm.fnOnPostList(vm.expInfoListModel.pager.pageNo);
    }
    , fnOrderChange: function (_order) {
      this.expInfoListModel.order = _order;
      let pageType = $("#pageType").val();

      if (pageType == "expSearchList") {
        this.fnOnPostSearchList(1);
      } else {
        this.fnOnPostList(1);
      }
    }
    , fnSetRegionList() {
      let vm = this;
      let param = {};
      Axios.post("/api/expinfo/setSeoulAreaList", param).then(function (response) {

        vm.expInfoListModel.regionList = response.data.expinfoCodeList;
        vm.expInfoListModel.expInfoCodeList = response.data.expinfoCodeList;

        if (vm.searchStr[0])
        {
          vm.expInfoListModel.regionList.forEach((item) => {
            if (vm.searchStr[0] == item.cmm_sys_cd)
            {
              vm.viewYnModel.region = item;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    }

    , fnMyRegion: function (value) {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey == null || _userKey == "") {
        swal({
          text: "내지역 정렬은 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          // icon : this.fnOnLoadSwalImageData("info"),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      } else {
        if (value == "on") {
          vm.expInfoListModel.deviseCode = "region";
          let _myRegion = vm.expInfoListModel.myRegion;
          vm.expInfoListModel.isRegion = value;

          $("#selectTag").children("li").removeClass("on");
          $("#selectTag").children("li:eq(1)").addClass("on");

          vm.expInfoListModel.upCode = 'SGGNV00100';
          this.fnSetRegionList();

          $("#findTag").children("li").removeClass("on");

          vm.fnOnclickTab(_myRegion);

          setTimeout(function () {
            vm.setMyRegion(_myRegion);
          }, 300);
        } else {
          $("#findTag").children("li").removeClass("on");

          $("#all").addClass("on");

          vm.expInfoListModel.isRegion = value;
          vm.fnOnclickTab('all');
        }
      }
    }
    , setMyRegion(myRegion) {
      let vm = this;
      var _class = "#" + myRegion;
      $(_class).addClass("on");
      vm.tabFocus(myRegion);
    }
    , fnOnSearchCode: function (_code) {
      let vm = this;
      let upcode = '';

      if (_code == 'scope') {
        upcode = 'DIVNVSCLNV000000';
      } else if (_code == 'progress') {
        upcode = 'STSNVAPRNV000100';
      } else if (_code == 'area') {
        upcode = 'CPCNVADMNV000000';
      } else if (_code == 'aff') {
        upcode = 'AFLNVADMNV000000';
      }

      let param = {
        searchCode: upcode
      };

      Axios.post("/api/expinfo/code", param).then(function (response) {
        if (_code == 'scope') {
          vm.expInfoListModel.scopeList = response.data.expinfoCodeList;
        } else if (_code == 'progress') {
          vm.expInfoListModel.progressList = response.data.expinfoCodeList;
        } else if (_code == 'area') {
          vm.expInfoListModel.areaList = response.data.expinfoCodeList;
        } else if (_code == 'aff') {
          vm.expInfoListModel.affList = response.data.expinfoCodeList;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , saveExpBestState(immediate) {
      try {
        const state = {
          ts: Date.now(),
          order: this.expInfoListModel.order,
          isNonface: this.expInfoListModel.isNonface,
          pageNo: this.expInfoListModel.pager.pageNo,
          totalCount: this.expInfoListModel.pager.totalSize,
          list: this.expInfoListModel.expInfoList,
          searchStr: this.searchStr,
          filters: {
            region: this.viewYnModel.region ? this.viewYnModel.region.cmm_sys_cd : '',
            trget: this.viewYnModel.trget ? this.viewYnModel.trget.cmm_sys_cd : '',
            affiliation: this.viewYnModel.affiliation ? this.viewYnModel.affiliation.cmm_sys_cd : '',
            capacity: this.viewYnModel.capacity ? this.viewYnModel.capacity.cmm_sys_cd : '',
            price: this.viewYnModel.price ? this.viewYnModel.price.cmm_sys_cd : '',
            progress: this.viewYnModel.progress ? this.viewYnModel.progress.cmm_sys_cd : ''
          },
          scrollY: window.scrollY
        };
        sessionStorage.setItem(EXP_BEST_STATE_KEY, JSON.stringify(state));
        if (!immediate) {
          // console.log('[EXP_BEST] state saved', state);
        }
      } catch (e) {
        console.log('[EXP_BEST] save state error', e);
      }
    }
    , restoreExpBestState() {
      const raw = sessionStorage.getItem(EXP_BEST_STATE_KEY);
      if (!raw) return false;
      try {
        const st = JSON.parse(raw);
        // TTL 15분
        if (Date.now() - st.ts > 15 * 60 * 1000) {
          sessionStorage.removeItem(EXP_BEST_STATE_KEY);
          return false;
        }
        this.expInfoListModel.order = st.order || this.expInfoListModel.order;
        this.expInfoListModel.isNonface = st.isNonface || this.expInfoListModel.isNonface;
        this.expInfoListModel.pager.pageNo = st.pageNo || 1;
        this.expInfoListModel.pager.totalSize = st.totalCount || 0;
        this.expInfoListModel.expInfoList = st.list || [];
        this.searchStr = st.searchStr || [ st.filters?.region || '', st.filters?.trget || '', st.filters?.affiliation || '', st.filters?.price || '', st.filters?.progress || '' ];
        // UI 계산치 갱신
        this.rm = Math.min(5, Math.floor(this.expInfoListModel.expInfoList.length / 4));
        // 로딩바 숨김
        this.isLoading = false;
        try { $('#load-2').hide(); } catch (e) {}
        // 스크롤 위치 복구
        this.$nextTick(() => {
          window.scrollTo(0, st.scrollY || 0);
        });
        // 복원 즉시 상태 삭제하여 '뒤로가기 시 사라지는' 패턴 유지
        sessionStorage.removeItem(EXP_BEST_STATE_KEY);
        return true;
      } catch (e) {
        console.log('[EXP_BEST] restore state error', e);
        return false;
      }
    }
    , fnReset() {
      let vm = this;

      vm.expInfoListModel.regionValues = [];
      vm.expInfoListModel.priceValues = [];
      vm.expInfoListModel.progressValues = [];
      vm.expInfoListModel.scopeValues = [];
      vm.expInfoListModel.areaValues = [];
      vm.expInfoListModel.affValues = [];

      vm.expInfoListModel.allScopeChecked = false;
      vm.expInfoListModel.allPriceChecked = false;
      vm.expInfoListModel.allProgressChecked = false;
      vm.expInfoListModel.allAreaChecked = false;
      vm.expInfoListModel.allAbilityChecked = false;
      vm.expInfoListModel.allLineChecked = false;

      vm.expInfoListModel.startDate = '';
      vm.expInfoListModel.endDate = '';
      vm.expInfoListModel.kword = '';

      this.fnOnPostSearchList(1);
    }
    , fnOnSetCode: function (_code) {
      let vm = this;
      let param = {searchCode: _code};

      Axios.post("/api/expinfo/code", param).then(function (response) {

        if (_code === 'DIVNVSCLNV000000') {
          vm.expInfoListModel.scopeList = response.data.expinfoCodeList;
          if (vm.searchStr[1])
          {
            vm.expInfoListModel.scopeList.forEach(function (item) {
              if (vm.searchStr[1] == item.cmm_sys_cd)
              {
                vm.viewYnModel.trget = item;
              }
            })
          }
          // }else if(_code === 'STSNVAPRNV000100'){
        } else if (_code === 'IXVNV00000') {
          // 조성이 팀장님 요청으로 오류, 일시신청중지 삭제
          vm.expInfoListModel.progressList = [];
          response.data.expinfoCodeList.forEach(function(item) {
            if(item.cmm_sys_cd != 'IXVNV00006' && item.cmm_sys_cd != 'IXVNV00009') {
              vm.expInfoListModel.progressList.push(item);
            }
          });

          if (vm.searchStr[4])
          {
            vm.expInfoListModel.progressList.forEach(function (item) {
              if (vm.searchStr[4] == item.cmm_sys_cd)
              {
                vm.viewYnModel.progress = item;
              }
            })
          }
          //vm.expInfoListModel.progressList = response.data.expinfoCodeList;
        } else if (_code === 'CPCNVADMNV000000') {
          vm.expInfoListModel.areaList = response.data.expinfoCodeList;
        } else if (_code === 'AFLNVADMNV000000') {
          vm.expInfoListModel.affList = response.data.expinfoCodeList;
          if (vm.searchStr[2])
          {
            vm.expInfoListModel.affList.forEach(function (item) {
              if (vm.searchStr[2] == item.cmm_sys_cd)
              {
                vm.viewYnModel.affiliation = item;
              }
            })
          }
        } else if (_code === 'ESGNVMNGNV00000') {
          vm.expInfoListModel.esgList = response.data.expinfoCodeList;
        } else if (_code === 'SCHDNVYTHNV00000') {
          vm.expInfoListModel.planList = response.data.expinfoCodeList;
          if (vm.expInfoListModel.planList.length > 0) {
            vm.expInfoListModel.planList.forEach(function (object) {
              if (object.cmm_sys_cd === response.data.expinfoCodeList.cmm_sys_cd) {
                vm.selectPlanType = object;
              }
            });
          }
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //체크박스 스타일이벤트
    , tabSwitch: function () {
      $('.tab_switch_js').each(function () {
        var tab = $(this).children('li');

        tab.on('click', function (e) {
          e.preventDefault();
          tab.removeClass('on');
          $(this).addClass('on');
        })

        tab.on('keydown', function (e) {
          if (e.key == "Enter") {

            e.preventDefault();
            tab.removeClass('on');
            $(this).addClass('on');
          }

        })
      })
    }
    , tabSlide: function () {
      var tabSwiper = new Swiper('.tab_container', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        speed: 500,
        mousewheel: {
          invert: false,
        },
        preventClicksPropagation: false,
        observer: true,
        observeParents: true
      });

      //탭 클릭시 활성화된것 가운데로 이동
      var $snbSwiperItem = $('.tab_container .swiper-slide a');
      $snbSwiperItem.click(function () {
        var target = $(this).parent();
        $snbSwiperItem.parent().removeClass('on')
        target.addClass('on');
        muCenter(target);
      })

      function muCenter(target) {
        var snbwrap = $('.tab_container .swiper-wrapper');
        var targetPos = target.position();
        var box = $('.tab_container');
        var boxHarf = box.width() / 2;
        var pos;
        var listWidth = 0;

        snbwrap.find('.swiper-slide').each(function () {
          listWidth += $(this).outerWidth();
        })

        var selectTargetPos = targetPos.left + target.outerWidth() / 2;
        if (selectTargetPos <= boxHarf) { // left
          pos = 0;
        } else if ((listWidth - selectTargetPos) <= boxHarf) { //right
          pos = listWidth - box.width();
        } else {
          pos = selectTargetPos - boxHarf;
        }

        setTimeout(function () {
          snbwrap.css({
            "transform": "translate3d(" + (pos * -1) + "px, 0, 0)",
            "transition-duration": "500ms"
          })
        }, 200);
      }
    }
    , tabFocus: function (sggCd) {
      let vm = this;
      var $snbSwiperItem = $('.tab_container .swiper-slide a');
      var target = $("#" + sggCd);
      $snbSwiperItem.parent().removeClass('on')
      target.addClass('on');
      vm.muCenter(target);
    }
    , muCenter: function (target) {
      var snbwrap = $('.tab_container .swiper-wrapper');
      var targetPos = target.position();
      var box = $('.tab_container');
      var boxHarf = box.width() / 2;
      var pos;
      var listWidth = 0;

      snbwrap.find('.swiper-slide').each(function () {
        listWidth += $(this).outerWidth();
      })

      var selectTargetPos = targetPos.left + target.outerWidth() / 2;
      if (selectTargetPos <= boxHarf) { // left
        pos = 0;
      } else if ((listWidth - selectTargetPos) <= boxHarf) { //right
        pos = listWidth - box.width();
      } else {
        pos = selectTargetPos - boxHarf;
      }

      setTimeout(function () {
        snbwrap.css({
          "transform": "translate3d(" + (pos * -1) + "px, 0, 0)",
          "transition-duration": "500ms"
        })
      }, 200);
    }
    , fnGetMapMarker: function () {
      let vm = this;
      // 마커가 표시될 위치입니다
      var markerPosition = new kakao.maps.LatLng(vm.expinfoDetailModel.detail.mapX, vm.expinfoDetailModel.detail.mapY);

      // 마커를 생성합니다
      var marker = new kakao.maps.Marker({
        position: markerPosition,
        map: this.map
      });

    }
    , fnInsertZzim(_item) {
      let vm = this;
      let _userKey = $("#userKey").val();
      let grpCode = $("#grpCode").val();

      if (_userKey != null && _userKey != "") {
        _item.isZzim = !_item.isZzim
        _item.zzimYn = (_item.isZzim) ? 'Y' : 'N';

        let param = {
          programUid: _item.uidKey
          , zzimYn: _item.zzimYn
        };

        Axios.post("/api/expinfo/checkZzim", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          vm.fnSwalAlert("오류가 발생했습니다.");
          console.log(ex);
        });
      } else {
        swal({
          text: "찜하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          // icon : this.fnOnLoadSwalImageData("info"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      }
    }
    , fnFileDownload(item) {
      let filepath = item.file_path;
      filepath = filepath.substr(14);

      location.href = filepath + "/" + item.file_new_name;
    }
    , fileDownload(item) {
      let _uidKey = $("#uid").val();
      let _fileNewName = item.file_new_name;

      let param = {
        uidKey: _uidKey
        , fileNewName: _fileNewName
      };

      Axios.post("/api/expinfo/fileDownload", param, {
        responseType: "blob",
      }).then(function (response) {
        function replaceAll(str, searchStr, replaceStr) {
          return str.split(searchStr).join(replaceStr)
        }

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ')
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url);
      }).catch(function (ex) {
        alert("오류가 발생했습니다.");
        console.log(ex);
      });
    }
    , fnUpdateMessage: function (evt) {
      this.inputChange = evt.message;
    }
    ///////////////////////////////////////////////////////////////////////////////////////
    , fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon       : this.fnOnLoadSwalImageData('warning'),
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    },
    fnSwalSuccess(_text, successFunction) {
      let vm = this;

      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon : vm.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            successFunction();
          }
        }
      });
    }
    , fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    }

    ///////////////////////////////////////////////////////////////////////////////////////

    //페이지 이동
    , fnGotoSearch() {
      let vm = this;

      let search = (vm.viewYnModel.region ? vm.viewYnModel.region.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : "");

      location.href = "/customer/expinfo/bestExperience?search=" + search;
    }
    , fnGotoDetailP(uid) {
      let vm = this;
      let pageType = $("#pageType").val();

      let search = (vm.viewYnModel.region ? vm.viewYnModel.region.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.price ? vm.viewYnModel.price.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.progress ? vm.viewYnModel.progress.cmm_sys_cd : "");

      // 베스트 체험 목록에서 상세로 이동할 때 현재 상태 저장 + 뒤로가기 복원 플래그 설정
      if (pageType === 'expBestList') {
        try {
          vm.saveExpBestState(true);
          sessionStorage.setItem(EXP_BEST_NAV_FROM_DETAIL_KEY, '1');
        } catch (e) { console.log('[EXP_BEST] set back intent error', e); }
      }

      location.href = "/customer/expinfo/detailExpinfo?uidKey=" + uid + "&search=" + search;
    }
    , fnGotoModefyP(uid) {
      location.href = "/youthnavi/mypage/manage/modifyExp?uidKey=" + uid;
    }
  }
  , watch: {
    inputChange: function (newVal, oldVal) {
      this.expinfoDetailModel.planOnOff = newVal;
    }
    , isMap: function (newVal) {
      if (newVal) {
        this.fnGetMapMarker();
      }
    }
    , searchStartDate: function (newValue, oldValue) {
      let vm = this;
      let endDt = vm.expInfoListModel.endDate;

      if ((endDt != null && endDt != "") && (newValue != null && newValue != "") && endDt < newValue) {
        vm.fnSwalAlert("시작일이 종료일보다 이후일 수 없습니다.");
        vm.searchStartDate = "";
        vm.expInfoListModel.startDate = "";
      } else {
        vm.expInfoListModel.startDate = newValue;
      }
    }
    , searchEndDate: function (newValue, oldValue) {
      let vm = this;
      let startDt = vm.expInfoListModel.startDate;

      if ((startDt != null && startDt != "") && (newValue != null && newValue != "") && startDt > newValue) {
        vm.fnSwalAlert("종료일이 시작일보다 이전일 수 없습니다.");
        vm.searchEndDate = "";
        vm.expInfoListModel.endDate = "";
      } else {
        vm.expInfoListModel.endDate = newValue;
      }
    }
  }
  , filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
    , changeMoment: function (date) {
      if (date == '') return '';

      let value = new Date(date);

      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let day = value.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }


      let fullDate = year + '.' + month + '.' + day;

      return fullDate;
    }
  }
});
